"use client";
import f from "./index.es141.js";
import "./index.es73.js";
import e from "react";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import b from "./index.es142.js";
import s from "./index.es143.js";
const d = f.div`
  .bl-info-box {
    overflow: visible;
  }
`, _ = ({
  type: c = "normal",
  content: o,
  title: t,
  sourceText: r,
  sourceUrl: m,
  className: a,
  tooltips: n,
  keyContext: i,
  htmlId: l
}) => {
  if (c === "infobox") {
    const p = l ? /* @__PURE__ */ e.createElement("h3", { id: l }, t) : t;
    return /* @__PURE__ */ e.createElement(d, { className: "bl-p-b-3" }, /* @__PURE__ */ e.createElement(b, { header: p }, /* @__PURE__ */ e.createElement(
      s,
      {
        content: o,
        keyContext: i,
        tooltips: n,
        className: a
      }
    ), r && m && /* @__PURE__ */ e.createElement("span", null, "Kilde:", " ", /* @__PURE__ */ e.createElement("a", { className: "bl-link", href: m }, r))));
  } else
    return /* @__PURE__ */ e.createElement("div", { className: "bl-p-b-3" }, !!t && /* @__PURE__ */ e.createElement("h3", { className: "bl-size-3", ...l ? { id: l } : {} }, t), /* @__PURE__ */ e.createElement(
      s,
      {
        content: o,
        keyContext: i,
        tooltips: n,
        className: a
      }
    ));
};
export {
  _ as default
};
//# sourceMappingURL=index.es81.js.map
